<script setup>
import EmptyState from 'dashboard/components/widgets/EmptyState.vue';
import { onMounted, computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const toggleSupportWidgetVisibility = () => {
  if (window.$talka) {
    window.$talka.toggleBubbleVisibility('show');
  }
};

const setupListenerForWidgetEvent = () => {
  window.addEventListener('talka:on-message', () => {
    toggleSupportWidgetVisibility();
  });
};

const currentAccount = computed(() => store.getters.getCurrentAccount);
const isExpired = computed(() => currentAccount.value.expired);

const pageTitle = computed(() =>
  isExpired.value
    ? 'APP_GLOBAL.ACCOUNT_EXPIRED.TITLE'
    : 'APP_GLOBAL.ACCOUNT_SUSPENDED.TITLE'
);

const pageMessage = computed(() =>
  isExpired.value
    ? 'APP_GLOBAL.ACCOUNT_EXPIRED.MESSAGE'
    : 'APP_GLOBAL.ACCOUNT_SUSPENDED.MESSAGE'
);

onMounted(() => {
  toggleSupportWidgetVisibility();
  setupListenerForWidgetEvent();
});
</script>

<template>
  <div class="items-center bg-slate-50 flex justify-center h-full w-full">
    <EmptyState :title="$t(pageTitle)" :message="$t(pageMessage)" />
  </div>
</template>
